import axios from "../../config/axiosConfig";

export default class DevisService {
  addDevis = async (data) => {
    try {
      const response = axios.post("/devis", data);
      return response.data;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la contact : " + error.message
      );
    }
  };
  getAllDevis = async () => {
    try {
      const response = axios.get("/devis");
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
}
